import ToastsStore from '@/store/toasts'
import { Clipboard } from '@capacitor/clipboard'
import { Capacitor } from '@capacitor/core'

export const copyToClipboard = async (text: string) => {
  const toastsStore = ToastsStore()
  
  if (Capacitor.isNativePlatform()) {
    await Clipboard.write({ string: text })
    toastsStore.add({ content: useNuxtApp().$i18n.t('components.Clipboard.success') })
  } else if (process.client && navigator.clipboard) {
    navigator.clipboard.writeText(text)
    toastsStore.add({ content: useNuxtApp().$i18n.t('components.Clipboard.success') })
  } else {
    toastsStore.add({ content: useNuxtApp().$i18n.t('components.Clipboard.error'), type: 'failure' })
  }

  console.log(useNuxtApp().$i18n.t('components.Clipboard.success') + ' ' + text)
  
  return
}